
export default {
    name: 'SvgCamera',
    props: {
        color: {
            type: String,
            default: '#ffffff',
        },
    },
};
